/* tslint:disable */
/* eslint-disable */
/**
 * Green0meter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';

export const BASE_PATH = "http://localhost".replace(/\/+$/, "");

/**
 *
 * @export
 */
export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};

/**
 *
 * @export
 * @interface RequestArgs
 */
export interface RequestArgs {
    url: string;
    options: RawAxiosRequestConfig;
}

const refreshToken = async (): Promise<string> => {
  try {
    const refreshToken = localStorage.getItem("refresh_token") as string;
    const response = await fetch(`${process.env.API_BASE_URL}auth/refresh`, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams({ refresh_token: refreshToken.toString() }),
    });
    const { access_token, refresh_token } = await response.json();

    if (access_token && refresh_token) {
      localStorage.setItem("access_token", access_token);
      localStorage.setItem("refresh_token", refresh_token);
    }

    return access_token;
  } catch (error) {
    console.error("Refresh token failed", error);
    throw error;
  }
};

let isRefreshing = false;
let refreshPromise: Promise<string> | null = null;

globalAxios.interceptors.request.use(function (config) {
  const token = localStorage.getItem("access_token");

  if (!token) return config;
  config.headers.Authorization = `Bearer ${localStorage.getItem("access_token")}`;

  return config;
}, async function (error) {
  const originalRequest = error.config;

  if (error.response.status === 401 && !originalRequest._retry) {
    originalRequest._retry = true;

    if (isRefreshing) {
      try {
        const refreshedToken =  await refreshPromise;

        originalRequest.headers["Authorization"] = `Bearer ${refreshedToken}`;

        return globalAxios(originalRequest);
      } catch (err) {
        return Promise.reject(err);
      }
    }

    isRefreshing = true;
    try {
      refreshPromise = refreshToken();

      setInterval(() => (isRefreshing = false), 15000);

      const newAccessToken = await refreshPromise;

      refreshPromise = null;

      originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;

      return globalAxios(originalRequest);
    } catch (err) {
      // TODO this should logout user (redirect to login page)
      refreshPromise = null;

      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");

      return Promise.reject(err);
    }
  }

  return Promise.reject(error);
});

/**
 *
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
    protected configuration: Configuration | undefined;

    constructor(configuration?: Configuration, protected basePath: string = BASE_PATH, protected axios: AxiosInstance = globalAxios) {
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath ?? basePath;
        }
    }
};

/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
    constructor(public field: string, msg?: string) {
        super(msg);
        this.name = "RequiredError"
    }
}

interface ServerMap {
    [key: string]: {
        url: string,
        description: string,
    }[];
}

/**
 *
 * @export
 */
export const operationServerMap: ServerMap = {
}
